module.exports = __webpack_public_path__ + "38504181dc99fac3a6159710df9e885b.svg";